import { render, staticRenderFns } from "./popups.vue?vue&type=template&id=20d74ebd&scoped=true"
import script from "./popups.vue?vue&type=script&lang=js"
export * from "./popups.vue?vue&type=script&lang=js"
import style0 from "./popups.vue?vue&type=style&index=0&id=20d74ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d74ebd",
  null
  
)

export default component.exports